module.exports = __webpack_public_path__ + "media/img/private-venue/bg-hover-unique-26b090363441a9df7f3088757ffeffdb.png";